/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

/**
 * Checks response headers for redirect URLs
 */
import { UntilDestroy } from '@ngneat/until-destroy';
import { RoutingService } from '../routing.service';
import { CredentialsService } from '../authentication/credentials.service';
import { encryptData } from '../utils/encryption.utils';
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class RedirectInterceptor implements HttpInterceptor {
  private credentialsService = inject(CredentialsService);
  private routerService = inject(RoutingService);

  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event) => {
        console.log(event);
        if (event instanceof HttpResponse) {
          const redirectUrl = event.headers.get('X-Redirect-Url');
          const internalRedirectUrl = event.headers.get(
            'X-Internal-Redirect-Url',
          );
          let token = '';
          const savedCredentials =
            sessionStorage.getItem('credentials') ||
            localStorage.getItem('credentials');
          if (savedCredentials) {
            token = JSON.parse(savedCredentials)?.access_token;
            console.log(token);
          }
          if (internalRedirectUrl) {
            this.handleRedirect(internalRedirectUrl, token);
          } else if (redirectUrl) {
            this.handleRedirect(redirectUrl);
          }
        }
      }),
    );
  }

  private handleRedirect(url: string, token?: string): void {
    if (!url.startsWith('http')) {
      this.routerService.openUrl([url]);
    } else {
      if (token) {
        const encryptedToken = encryptData(token);
        const urlWithToken =
          url + (url.includes('?') ? '&' : '?') + 'dtr=' + encryptedToken;
        window.location.href = urlWithToken;
      } else {
        window.location.href = url;
      }
    }
  }
}
